import { render, staticRenderFns } from "./GoodDetailBulkDialog.vue?vue&type=template&id=42f2f08a"
import script from "./GoodDetailBulkDialog.vue?vue&type=script&lang=js"
export * from "./GoodDetailBulkDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports